
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Box, Grid2, Stack } from '@mui/material';
import Container from '@mui/material/Container';

const Number = ({ num }) => {
  return (
    <Box sx={{
      background: theme => theme.palette.primary.main, p: 1, borderRadius: '50%', width: '25px', height: '25px', display: 'flex',
      alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1rem', color: 'white'
    }}>
      {num}
    </Box>
  )
}

const ListItem = ({ num, text, title }) => {
  return (
    <Stack direction={'row'} alignItems={'center'} sx={{color:'text.secondary'}}>
      <Number num={num} />
      <Box sx={{fontWeight:600}}>{title}</Box> : {text}
    </Stack>
  )
}

export default function Importance() {


  return (
    <React.Fragment>
      <Container maxWidth="xl" sx={{ my: 5 }}>
        <Grid2 container justifyContent={'space-between'}>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant='h5'>The Importance of Real-time Monitoring and Automation in Business
            </Typography>
            <Typography sx={{color:'text.secondary'}}>
            Effective monitoring ensures early detection of potential disruptions, allowing businesses to act before significant issues arise. Automating responses not only reduces manual intervention but also speeds up resolutions, minimizes downtime, and keeps operations running smoothly. Key points include:            
            </Typography>
            <br />
            <Stack spacing={2}>
              <ListItem num={1} text={'Real-time monitoring identifies issues early and minimizes operational disruptions.'} title={'Enhanced Incident Detection'}/>
              <ListItem num={2} text={'Automation reduces the need for human intervention, accelerating incident resolution.'} title={'Automated Response Mechanisms'}/>
              <ListItem num={3} text={'Faster issue resolution enhances productivity, customer experience, and business continuity.'} title={'Optimized Operational Efficiency'}/>
          </Stack>
          <br />
            <Typography sx={{color:'text.secondary'}}>
            With Callgoose SQIBS Incident Management and Automation Platform, businesses can monitor real-time alerts from monitoring or observability platforms and instantly respond via automated workflows or escalate issues to the correct teams.            </Typography>

          </Grid2>
        </Grid2>
      </Container>
    </React.Fragment>
  );
}
